import s from './Markdown.module.css';

const STARTS_NEW_LINE = /^\d+\./;
const HEADING = /^\d+\.\s/;

/**
 * The served legal documents un-wrapped into their logical lines — the phone's `parseLegalText`,
 * mirrored (the backend's `test_legal_document_shape.py` pins the rule both follow). The catalogue
 * hard-wraps at about 100 columns so the Python file diffs well; rendered literally, those newlines
 * broke sentences mid-line at whatever width the card was. A new line begins at column 0 with `1.` or
 * `1.1`, and at a blank-line paragraph break (so the title and the preamble do not run together);
 * anything else, indented or not, continues the line before.
 */
export function legalLines(content: string): string[] {
  const lines: string[] = [];
  for (const paragraph of content.replace(/\r\n/g, '\n').split(/\n[ \t]*\n/)) {
    let first = true;
    for (const raw of paragraph.split('\n')) {
      const line = raw.trim();
      if (!line) continue;
      const continues = /^\s/.test(raw) || !STARTS_NEW_LINE.test(line);
      const starts = first || !continues;
      first = false;
      if (lines.length === 0 || starts) lines.push(line);
      else lines[lines.length - 1] = `${lines[lines.length - 1]} ${line}`;
    }
  }
  return lines;
}

/**
 * A legal document as the accept screen shows it: the title, then each section heading and clause
 * on its own line. Plain text, never HTML. Not through `Markdown`, which would read a heading such as
 * "8. CHILDREN" as an ordered list and renumber it from 1.
 */
export function LegalText({ content }: { content: string }) {
  const [title, ...rest] = legalLines(content);
  return (
    <div className={s.md}>
      {title && <h3>{title}</h3>}
      {/* A section heading is a numbered line in capitals ("4. INTERNATIONAL TRANSFERS"). */}
      {rest.map((line, i) => (HEADING.test(line) && line === line.toUpperCase() ? <h4 key={i}>{line}</h4> : <p key={i}>{line}</p>))}
    </div>
  );
}
